module.exports = __webpack_public_path__ + "static/media/images_WhatsApp.e2809d55.png";